@if (rb$ | async; as acs) {
<div class="screen">
  <div class="rulebook-content">
    <div class="button-line">
      <h3>Rulebook:&nbsp;{{ decodeHtml(acs.rbName) }}</h3>
    </div>
    <div [innerHTML]="acs.summary"></div>
    @for (sect of acs.sect; track sect) {
    <mat-card class="section-level">
      <mat-card-title
        >Section&nbsp;{{ sect.rbSectNum }}:&nbsp;{{
          sect.rbSectName
        }}</mat-card-title
      >
      <mat-card-content>
        @if (sect.sectionStateDifference) { @for (sectsd of
        sect.sectionStateDifference; track sectsd) {
        <div class="statediff">
          <div [innerHTML]="sectsd"></div>
        </div>
        } } @for (para of sect.para; track para) {
        <div>
          @if (para.question) {
          <div class="paragraph-content">
            <span>Paragraph&nbsp;{{ para.paraNum }}</span>
            <div [innerHTML]="para.question"></div>
          </div>
          <p
            [ngClass]="{ hideguide: hideGuidenote }"
            class="guidenote"
            [innerHTML]="para.guideNote"
          ></p>
          } @if (para.paraStateDifference) { @for (parasd of
          para.paraStateDifference; track parasd) {
          <div class="statediff">
            <div [innerHTML]="parasd"></div>
          </div>
          } }

          <mat-divider></mat-divider>
        </div>
        }
      </mat-card-content>
    </mat-card>
    }
  </div>
</div>
} @if (rb$ | async; as acs) {
<div class="print">
  <div class="rulebook-content">
    <div class="button-line">
      <h2>{{ auditName }}</h2>
      <h4>{{ decodeHtml(acs.rbName) }}</h4>
    </div>
    <div class="summary">
      <div [innerHTML]="acs.summary"></div>
    </div>
    @for (sect of acs.sect; track sect) {
    <mat-card class="section-level">
      <mat-card-title>
        <div fxLayout="column" fxFill>
          <div fxLayout fxFlex>
            <div fxFlex="70" class="one">
              Section&nbsp;{{ sect.rbSectNum }}:&nbsp;{{ decodeHtml(sect.rbSectName) }}
            </div>
            <div fxLayout fxFlex="30" class="equally">
              <div fxFlex="30">N/A</div>
              <div fxFlex="30">Comply</div>
              <div>Not Comply</div>
            </div>
          </div>
        </div>
      </mat-card-title>
      <mat-card-content>
        @if (sect.sectionStateDifference) { @for (sectsd of
        sect.sectionStateDifference; track sectsd) {
        <div class="statediff">
          <div [innerHTML]="sectsd"></div>
          <div>N/A</div>
          <div>Comply</div>
          <div>Not comply</div>
        </div>
        } } @for (para of sect.para; track para) {
        <div>
          @if (para.question) {
          <div class="paragraph-content">
            <div fxLayout="column" fxFill>
              <div fxLayout fxFlex>
                <div
                  class="para"
                  fxFlex="70"
                  [innerHTML]="para.paraNum + '&nbsp;' + para.question"
                ></div>
                <div fxLayout fxFlex="30" class="equally">
                  <mat-checkbox fxFlex="30"></mat-checkbox
                  ><mat-checkbox fxFlex="30"></mat-checkbox
                  ><mat-checkbox></mat-checkbox>
                </div>
              </div>
            </div>
          </div>
          } @if (para.paraStateDifference) { @for (parasd of
          para.paraStateDifference; track parasd) {
          <div class="statediff">
            <div [innerHTML]="parasd"></div>
            <div>N/A</div>
            <div>Complies</div>
            <div>Do not comply</div>
          </div>
          } }
          <p
            [ngClass]="{ hideguide: hideGuidenote }"
            class="guidenote"
            [innerHTML]="para.guideNote"
          ></p>
        </div>
        }
      </mat-card-content>
    </mat-card>
    }
  </div>
</div>
}
